import jsQR from "jsqr";

/**
 * Draw a line on canvas between two points
 */
// function drawLine(ctx, begin, end, color = "#FF3B58") {
//   ctx.beginPath();
//   ctx.moveTo(begin.x, begin.y);
//   ctx.lineTo(end.x, end.y);
//   ctx.lineWidth = 4;
//   ctx.strokeStyle = color;
//   ctx.stroke();
// }

/**
 * Scan a video frame for QR codes and call onDetection with the decoded data.
 * Also draws the QR code outline on the canvas.
 *
 * @param {HTMLVideoElement} video - Live camera video element
 * @param {HTMLCanvasElement} canvas - Canvas to draw QR outline on
 * @param {Function} onDetection - Callback called with the QR code string when found
 */
export const detectQRFromVideo = (video, canvas, onDetection) => {
  if (!video.videoWidth || !video.videoHeight) return;

  const ctx = canvas.getContext("2d");

  // Match canvas size to video
  if (canvas.width !== video.videoWidth || canvas.height !== video.videoHeight) {
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
  }

  // Draw current video frame onto canvas
  ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

  // Get pixel data for jsQR
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const code = jsQR(imageData.data, imageData.width, imageData.height, {
    inversionAttempts: "dontInvert",
  });

  // Always clear the canvas (no visual overlay)
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  if (code) {
    if (onDetection) {
      onDetection(code.data);
    }
  }
};
